import React from 'react'
import { useHistory } from 'react-router-dom'
import styles from './KitSelectPage.module.css'
import MakeHeader from '../ReusableComponents/Header/MakeHeader' // Adjust path if needed

const KitSelectPage = () => {
    const history = useHistory()

    const handleBack = () => {
        history.push('/kitSelection')
    }

    const handleKit1 = () => {
        window.open('https://plode.org/play/#/playdynamex', '_blank')
    }

    const handleKit2 = () => {
        history.push('/playdynamex-main')
    }

    return (
        <div className={`Main_Select`}>
            {/* Standard platform header */}
            <div className="Select_Headers">
                <MakeHeader
                    title="Projects"
                    titlePosition="left"
                    help_btnPosition="right"
                    isGoBack={true}
                    goBack={handleBack} 
                    showAccountSetting={true}
                    showHelp={true}
                    showBluetoothBtn={false}
                />
            </div>

            {/* Centered Main Content Area */}
            <div className={styles.contentWrapper}>
                <div className={styles.container}>
                    <h1 className={styles.mainTitle}>Select Your Kit</h1>
                    <p className={styles.subTitle}>Choose a kit to start building your projects</p>

                    <div className={styles.cardGroup}>
                        {/* Kit 1 Card */}
                        <div className={styles.selectionCard} onClick={handleKit1}>
                            <div className={`${styles.circleGraphic} ${styles.blueGradient}`}>
                                <span className={styles.cardText}>1</span>
                            </div>
                            <h2 className={`${styles.cardText} ${styles.blueText}`}>Kit 1</h2>
                        </div>

                        {/* Kit 2 Card */}
                        <div className={styles.selectionCard} onClick={handleKit2}>
                            <div className={`${styles.circleGraphic} ${styles.purpleGradient}`}>
                                <span className={styles.cardText}>2</span>
                            </div>
                            <h2 className={`${styles.cardText} ${styles.purpleText}`}>Kit 2</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KitSelectPage